export const BASE_URL =
  process.env.NODE_ENV === "development"
    ? process.env.REACT_APP_DEV_MODE
    : process.env.REACT_APP_PRO_MODE;
export const PICTURE_URL =
  process.env.NODE_ENV === "development"
    ? process.env.REACT_APP_DEV_MODE?.slice(0, -5)
    : process.env.REACT_APP_PRO_MODE?.slice(0, -5);
export const LOGIN_URL = BASE_URL + "login_check";
export const BRAND_URL = BASE_URL + "admin/brand";
export const BRAND_SETTINGS_URL = BASE_URL + "admin/brand-settings"
export const BRAND_CATEGORY_URL = BASE_URL + "admin/brand-category";
export const ADMIN_URL = BASE_URL + "admin/user/admins";
export const SUBSCRIPTION_URL = BASE_URL + "admin/subscription";
export const BANNER_URL = BASE_URL + "admin/banner";
export const BANNER_SETTINGS_URL = BASE_URL + "admin/banner-settings";
export const MENU_POSITION = BASE_URL + "admin/menu-position";
export const NEWS_THEME_URL = BASE_URL + "admin/news-theme";
export const NEWSLETTER_URL = BASE_URL + "admin/newsletter";
export const NEWSLETTER_ERROR_URL = BASE_URL + "admin/email/newsletter";
export const NEWSLETTER_SUBSCRIBER_URL =
  BASE_URL + "admin/newsletter-subscriber";
export const TEST_MAIL_URL = BASE_URL + "admin/newsletter-test-subscriber";
export const SETTINGS_URL = BASE_URL + "admin/settings";
export const SITE_SETTINGS = BASE_URL + "admin/site-settings";
export const MEDIADATEN = BASE_URL + "admin/mediadaten";
export const MENU_URL = BASE_URL + "admin/menu";
export const USER_URL = BASE_URL + "me";
export const USERS_URL = BASE_URL + "admin/user";
export const MARKET_URL = BASE_URL + "admin/market";
export const CATEGORY_URL = BASE_URL + "admin/news/category";
export const CATEGORY_AUTO_INFORMATION_URL = BASE_URL + "admin/auto-information/news-category";
export const SUBSCRIBER_AUTO_INFORMATION_URL = BASE_URL + "admin/auto-information/subscriber";
export const EDITIONS_URL = BASE_URL + "admin/editions";
export const CATEGORY_DOWNLOAD_URL = BASE_URL + "admin/download-category";
export const COMPANY_DETAILS_URL = BASE_URL + "admin/company";
export const DOWNLOAD_URL = BASE_URL + "admin/download";
export const EDUCATION_CONTINUING_URL = BASE_URL + "admin/continuing-education";
export const PAGE_URL = BASE_URL + "admin/page";
export const FLEET_URL = BASE_URL + "admin/fleet";
export const EVENT_CATEGORY_URL = BASE_URL + "admin/event-category";
export const EVENT_URL = BASE_URL + "admin/event";
export const PRODUCT_URL = BASE_URL + "admin/product";
export const PRODUCT_CATEGORY_URL = BASE_URL + "admin/product-category";
export const ALTERNATIVE_DRIVES_SETTINGS_URL =
  BASE_URL + "admin/alternative-drives-settings";
export const ALTERNATIVE_DRIVES_URL = BASE_URL + "admin/alternative-drives";
export const ALTERNATIVE_DRIVES_CATEGORY_URL =
  BASE_URL + "admin/alternative-drives-category";
export const EVENT_SUMMARY_CAT_URL = BASE_URL + "admin/event-summary/category";
export const EVENT_SUMMARY_URL = BASE_URL + "admin/event-summary";
export const MAGAZINE_CATEGORY_URL = BASE_URL + "admin/magazine-category";
export const MAGAZINE_URL = BASE_URL + "admin/magazine";
export const ALBUM_URL = BASE_URL + "admin/album";
export const GALLERY_URL = BASE_URL + "admin/gallery-image";
export const GALLERY_SETTINGS_URL = BASE_URL + "admin/gallery-settings"

export const VIDEO_URL = BASE_URL + "admin/video";
export const NEWS_URL = BASE_URL + "admin/news";
export const NEWS_AUTO_INFORMATION_URL = BASE_URL + "admin/auto-information/news";
export const MODEL_URL = BASE_URL + "admin/model";
export const MODEL_CATEGORY_URL = BASE_URL + "admin/model-category";
export const MODEL_GALLERY_URL = BASE_URL + "admin/model-gallery";
export const TESTS_URL = BASE_URL + "admin/tests-news";
export const WAITING_NEWS_URL = BASE_URL + "admin/waiting-news";
export const DASHOARD_URL = BASE_URL + "admin/dashboard";
export const RESET_PASSWORD_URL = BASE_URL + "admin/security/forgot-password";
export const TEAM_URL = BASE_URL + "admin/provider-team";
export const FIRM_URL = BASE_URL + "admin/firm";
export const FIRM_CATEGORY_URL = BASE_URL + "admin/firm-category";
export const FIRM_GALLERY_URL = BASE_URL + "admin/firm-gallery";
export const EMPLOYEE_URL = BASE_URL + "admin/employee";
export const TEMPLATE_URL = BASE_URL + "admin/template"
export const TEMPLATE_SETTINGS_URL = BASE_URL + "admin/template-settings"
export const NOTIFICATION_URL = BASE_URL + "admin/auto-information/notification"
export const SPEAKER_URL = BASE_URL + "admin/speaker"
export const SPEAKER_SETTINGS_URL = BASE_URL + "admin/speaker-settings"
export const SPEAKER_SPECIFICATION_URL = BASE_URL + "admin/speaker-specification/key";
export const SECTION_URL = BASE_URL + "admin/section"
export const SECTION_SETTINGS_URL = BASE_URL + "admin/section-settings"
export const PROGRAM_URL = BASE_URL + "admin/program"
export const TARGET_GROUP_URL = BASE_URL + "admin/target-group"
export const INFO_URL = BASE_URL + "admin/info"
export const JOB_URL = BASE_URL + "admin/job"
export const JOB_SETTINGS_URL = BASE_URL + "admin/job-settings"
export const DRIVER_REGISTRATION_URL = BASE_URL + "admin/driver-registration"
export const DRIVER_REGISTRATION_SETTINGS_URL = BASE_URL + "admin/driver-registration-settings"
